import React from "react";

const Loading = () => {
  return (
    <div id="loading">
      <div className="lds-ripple">
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loading;
